import { Citation } from "@/api/models";

/** Stable de-dupe key for a citation. */
export const citationKey = (citation: Citation): string =>
  citation.id || citation.url_citation?.url || citation.url || citation.title || '';

/**
 * De-duplicated citations, keeping the first occurrence of each source.
 *
 * A single source is frequently cited several times in one answer — once per
 * retrieved chunk — so any list *of sources* has to collapse them. Inline
 * citation markers are the exception: those index into the raw list and must
 * not be de-duplicated.
 *
 * @param {Citation[]} citations - The raw citation list
**/
export const dedupeCitations = (citations: Citation[] | null | undefined): Citation[] => {
  const seen = new Map<string, Citation>();

  (citations || []).forEach((citation, index) => {
    const key = citationKey(citation) || `idx-${index}`;
    if (!seen.has(key)) seen.set(key, citation);
  });

  return Array.from(seen.values());
};
